import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminUsersPage, type AdminUsersPageProps } from '../ui/admin/AdminUsersPage';

/**
 * AdminUsersPageContainer - Entry point for rendering admin users page in Rails
 */
export function AdminUsersPageContainer(props: AdminUsersPageProps) {
  return <AdminUsersPage {...props} />;
}

/**
 * Mount function for rendering from Rails
 */
export function mountAdminUsersPage(
  container: HTMLElement,
  props: AdminUsersPageProps
) {
  const root = createRoot(container);
  root.render(<AdminUsersPageContainer {...props} />);
  return root;
}

export default AdminUsersPageContainer;
